import { trans } from "@/app/localization/Trans";
import { BasePopover } from "@/app/popover/BasePopover";

export class TextPopover extends BasePopover {
    constructor(inner: JQuery) {
        super(undefined, false);

        this.$element.addClass("text");

        $('<button class="btn">' + trans.general.close + "</button>")
            .appendTo(inner)
            .click(() => {
                this.hide();
            });

        this.$body.append(inner);
    }

    protected onShow() {}

    protected onHide() {
        this.destroy();
    }

    protected onDestroy() {}

    public static showFor(title: string, text: string, btnHandle?: { () }, hideIfOthersAppear?: boolean) {
        const bd = $('<div class="inner"><h1>' + title + "</h1><p>" + text + "</p></div>");
        const s = new TextPopover(bd);

        if (hideIfOthersAppear !== undefined && hideIfOthersAppear === true) s.setHideIfOtherAppears(true);

        if (btnHandle !== undefined) s.onClosed = () => btnHandle();

        s.show();
    }

    public hideExisting() {}
}
